import { render, staticRenderFns } from "./MessagesDialog.vue?vue&type=template&id=1bea90f2&scoped=true&"
import script from "./MessagesDialog.vue?vue&type=script&lang=ts&"
export * from "./MessagesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MessagesDialog.vue?vue&type=style&index=0&id=1bea90f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bea90f2",
  null
  
)

export default component.exports